// extracted by mini-css-extract-plugin
export default {"board":"Dartboard_board__kM0dQ","btnBounce":"Dartboard_btnBounce__rnHFM"};